import { Locale } from '../types';
var VALID_LOCALES_INDEX = Object.values(Locale).reduce(function (acc, next) {
    acc[next.toLowerCase()] = true;
    return acc;
}, {});
export var isValidLocale = function (locale) {
    return locale.toLowerCase() in VALID_LOCALES_INDEX;
};
